import {css} from 'lit';
export const styles = css`:host {
  --app-primary-color: #01965f;
  --app-primary-color-400: #017243;

  --app-secondary-color: black;

  --accent-color: var(--google-red-500);
  --accent-color-400: var(--google-red-300);

  --accent-home: var(--google-red-500);
  --accent-home-400: var(--google-red-300);
  --accent-away: var(--google-green-500);
  --accent-away-400: var(--google-green-300);
}

:host {
    --page-content-width: 800px;
}

#container {
    display: flex;
    flex-direction: column;
    height: 100vh; /* 1, 3 */
}

#header,
#footer {
    flex: none; /* 2 */
}

#header {
    z-index: 1;
}

#footer {
    z-index: -1;
}

#content {
    flex: 1 0 auto; /* 2 */
    width: 100%;
    z-index: 0;
}

app-header-layout {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
}

app-header {
    color: #fff;
    background-color: var(--app-primary-color);
}

[role="content"] {
    max-width: var(--page-content-width);
    margin: auto;
}

[role="content"] {
    flex: 1;
    box-sizing: border-box;
    padding: 8px;
}

app-header, footer {
    flex-shrink: 0;
}

#footerTop {
    height: 15px;
    width: 100%;
    display: block;
}

#footerContent {
    padding: 0px 8px 8px 8px;
    background: var(--app-primary-color);
}
`;
export default styles;
